import type { PropsWithChildren } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { StyledFilterStateItem } from "./styles";

type Props = PropsWithChildren<{
    title: Translatable | string;
    filterKey?: string;
}>;

export const FilterStateItem = ({ title, children, filterKey }: Props) => {
    return (
        <StyledFilterStateItem
            data-automation="filter-state-item"
            data-filter-key={filterKey}
        >
            <Text
                data-automation="filter-name"
                fontVariant="sectionTitle"
                color={colorsPalettes.carbon[500]}
            >
                {is.string(title) ? title : <I18n translatable={title} />}
            </Text>

            {children}
        </StyledFilterStateItem>
    );
};
